/**
 * 日付の整形
 * @export
 * @param {string}origin 文字列YYYYMMDD: 20240112
 * @returns {string} 整形済み日付: 2024年1月12日(金)
 */
const formatWeekday = (origin: string): string => {
  if (!origin || origin.length !== 8) {
    return origin;
  }
  const year = origin.substring(0, 4);
  const month = origin.substring(4, 6);
  const day = origin.substring(6, 8);
  const originParsed = `${year}-${month}-${day}`;
  const originDate = new Date(originParsed);
  const dateString = originDate.toLocaleDateString('ja-JP', {
    weekday: 'short',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  const result: string = `${dateString}`;
  return result;
};
export default formatWeekday;